"use client";

import { usePageName } from "@/contexts/PageNameContext";
import {
  CaretDownIcon,
  CurrencyCircleDollarIcon,
  GearIcon,
  SignOutIcon,
} from "@phosphor-icons/react";
import Image from "next/image";
import DropdownMenu from "../ui/new-dropdown-menu";
import Badge from "../ui/new-badge";
import { useState } from "react";
import { useAppContext } from "@/contexts/AppContext";
import { useClerk } from "@clerk/nextjs";
import { useRouter } from "next/navigation";

export function Header() {
  const { pageTitle } = usePageName();

  return (
    <header className="flex items-center h-spacing-10 bg-transparent sticky top-0 z-50 gap-8">
      <div className="flex h-full w-full relative">
        <div className="flex items-center h-full w-full bg-palette-surface-solid-equivalent-default70 rounded-l-lg rounded-tr-lg pr-spacing-3 pl-spacing-8 border border-palette-border-default">
          <h5 className="h5-Medium text-palette-text-primary">{pageTitle}</h5>
        </div>
        <span className="bg-palette-surface-solid-equivalent-default70 h-full origin-top-right w-6 skew-x-18 rounded-tr-[10px] rounded-br-[10px] absolute right-0 border-t border-r border-b border-palette-border-default"></span>
      </div>
      <div className="flex h-full group rounded-r-lg min-w-[286px] relative">
        <span className="bg-palette-surface-solid-equivalent-default70 h-full origin-top-right w-8 skew-x-18 rounded-tl-[10px] rounded-bl-[10px] absolute right-[276px] border-t border-l border-b border-palette-border-default"></span>
        <ProfileDropdown />
      </div>
    </header>
  );
}

function ProfileDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const { user, currentPlan } = useAppContext();
  const { signOut, openUserProfile, session } = useClerk();
  const router = useRouter();

  const handleSignOut = async () => {
    await signOut();
    router.push("/sign-in");
  };

  const menuItems = [
    {
      text: "Settings",
      icon: <GearIcon />,
      onClick: () => openUserProfile(),
      type: "button",
    },
    {
      text: "Billing & Subscription",
      icon: <CurrencyCircleDollarIcon />,
      url: "/billing",
      type: "link",
    },
    {
      text: "Sign out",
      icon: <SignOutIcon />,
      divider: true,
      onClick: handleSignOut,
      type: "button",
    },
  ];

  return (
    <DropdownMenu menuItems={menuItems}>
      <div
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center justify-between w-full h-full pr-spacing-5 gap-spacing-5 border-t border-r border-b border-palette-grey-0 rounded-r-lg rounded-bl-lg bg-palette-surface-solid-equivalent-default70 hover:bg-palette-surface-container-hovered cursor-pointer active:bg-palette-surface-container"
      >
        <div className="flex items-center gap-spacing-3">
          <Image
            src={session?.user?.imageUrl ?? "/profile-test.jpg"}
            alt="Profile"
            width={40}
            height={40}
            className="rounded-full z-10"
          />
          <div>
            <p className="paragraphs-Medium-SemiBold text-palette-text-primary">
              {user?.firstName}
            </p>
            <Badge
              isLilac={currentPlan?.displayName !== "Free"}
              text={currentPlan?.displayName ?? ""}
            />
          </div>
        </div>
        <CaretDownIcon
          className={`text-palette-icon-default transition-transform ${isOpen ? "rotate-180" : ""}`}
          size={16}
        />
      </div>
    </DropdownMenu>
  );
}
